import { render, staticRenderFns } from "./ClaimingTricksModal.vue?vue&type=template&id=2fcddcfe&scoped=true&"
import script from "./ClaimingTricksModal.vue?vue&type=script&lang=js&"
export * from "./ClaimingTricksModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimingTricksModal.vue?vue&type=style&index=0&id=2fcddcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcddcfe",
  null
  
)

export default component.exports